import { lazy, Suspense, useEffect, useMemo } from "react";
import HeroStatic from "./hero3d/HeroStatic";
// The 3D engine (Three.js, GSAP, Lenis) is the heaviest part of the site, so it loads
// as a separate file and only on the home page. Every other page opens without it.
const SeplaHero3D = lazy(() => import("./hero3d/SeplaHero3D"));

function HeroPoster() {
  return <div className="hero-poster-fallback" style={{ backgroundImage: "url(/hero-poster.jpg?v=2)" }} aria-hidden="true" />;
}

const supports3D = () => {
  try {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return false;
    const c = document.createElement("canvas");
    return !!(window.WebGLRenderingContext && (c.getContext("webgl2") || c.getContext("webgl")));
  } catch {
    return false;
  }
};

/* 3D hero with an accessible static poster/list fallback. */
export default function SeplaHeroGate() {
  const use3D = useMemo(supports3D, []);
  useEffect(() => {
    if (!use3D) document.documentElement.style.scrollBehavior = "smooth";
  }, [use3D]);
  return use3D ? (
    <Suspense fallback={<HeroPoster />}>
      <SeplaHero3D />
    </Suspense>
  ) : (
    <HeroStatic />
  );
}
